import React, { Suspense } from 'react';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import 'react-multi-carousel/lib/styles.css';
import { useRoutes } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { CssBaseline } from '@mui/material';
import { LanguagesProvider } from './context/lng-context';
import { LawyerProvider } from './context/lawyer-info-context';
import Loading from './components/common/Loading';
import getRoutes from './routes';

const routes = getRoutes();

export default function App(): JSX.Element {
  const element = useRoutes(routes);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Адвокат Хачатуров Роман Сергійович</title>
        <link rel="canonical" href="https://www.advokat-khachaturov-roman.com/" />
        <meta name="description" content="Адвокат Хачатуров Роман Сергійович" />
      </Helmet>
      <CssBaseline />
      <Suspense fallback={<Loading height="100vh" />}>
        <LanguagesProvider>
          <LawyerProvider>{element}</LawyerProvider>
        </LanguagesProvider>
      </Suspense>
    </>
  );
}
